module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Patient-Zero.c0f771b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Patient-Zero.jpg
// module id = NUbJ
// module chunks = 0